import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EstoqueListComponent } from './estoque-list.component';
import { PoModule } from '@po-ui/ng-components';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [EstoqueListComponent],
  imports: [
    CommonModule, PoModule, FormsModule
  ]
})
export class EstoqueListModule { }
